"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var CartItem = /** @class */ (function (_super) {
    __extends(CartItem, _super);
    function CartItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            wasRemoveClicked: false
        };
        _this.onRemoveClick = function (variantId) { return function () {
            _this.setState({ wasRemoveClicked: true });
            _this.props.onRemoveClick(variantId);
        }; };
        return _this;
    }
    CartItem.prototype.render = function () {
        var _a = this.props, classes = _a.classes, lineItem = _a.lineItem;
        var wasRemoveClicked = this.state.wasRemoveClicked;
        var book = lineItem.book;
        if (!book) {
            return null;
        }
        var courses = book.courses || [];
        var opacity = wasRemoveClicked ? 0.5 : 1;
        return (React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.cartGridItem, style: { opacity: opacity } },
            React.createElement(Grid_1.default, { item: true, style: { width: 152 } }, book.imageUrl && (React.createElement("img", { src: book.imageUrl, style: { width: '100%' } }))),
            React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.lineItemDetails },
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.lineItemDetailTitleLine },
                        React.createElement(Typography_1.default, { variant: "h5", className: classes.itemBookTitle }, book.title),
                        lineItem.price !== null && React.createElement(Grid_1.default, { item: true },
                            "$",
                            lineItem.price.toFixed(2))),
                    book.authors && (React.createElement(Grid_1.default, { item: true },
                        React.createElement(Typography_1.default, { variant: "subtitle1" },
                            "by ",
                            book.authors)))),
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "subtitle1" }, courses.map(function (course, i) { return (React.createElement(React.Fragment, { key: i },
                        course.university && React.createElement(Typography_1.default, { variant: "subtitle1" }, course.university.name),
                        React.createElement(Typography_1.default, { variant: "subtitle1" }, course.name))); }))),
                React.createElement(Grid_1.default, { item: true, className: classes.removeButton },
                    React.createElement(Button_1.default, { disabled: wasRemoveClicked, color: "primary", onClick: this.onRemoveClick(lineItem.variantId) }, "Remove")))));
    };
    return CartItem;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(CartItem);
